import { render } from "./HistoriqueLecturePage.vue?vue&type=template&id=28d1ab3e&ts=true"
import script from "./HistoriqueLecturePage.vue?vue&type=script&lang=ts"
export * from "./HistoriqueLecturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__